import { IAPIDashboardActivityComparisonDataModel, IAPIDashboardRecentActivityDataModel, IAPIDashboardRecentActivityModel } from "../interfaces/IAPIDashboardModels";

 
export class ActivitiesModel {
  grossVolume: ActivitiesDataComparisonModel;
  netVolume: ActivitiesDataComparisonModel;
  payments: ActivitiesDataComparisonModel;
  newCustomers: ActivitiesDataComparisonModel;
  newSubscriptions: ActivitiesDataComparisonModel;
  constructor(data?: Partial<ActivitiesModel>) {
      this.grossVolume = new ActivitiesDataComparisonModel(data?.grossVolume);
      this.netVolume = new ActivitiesDataComparisonModel(data?.netVolume);
      this.payments = new ActivitiesDataComparisonModel(data?.payments);
      this.newCustomers = new ActivitiesDataComparisonModel(data?.newCustomers);
      this.newSubscriptions = new ActivitiesDataComparisonModel(data?.newSubscriptions);
  }

  static deserializeAPIModel(data: IAPIDashboardRecentActivityModel): ActivitiesModel {
      const mappedData: Partial<ActivitiesModel> = {
          grossVolume: ActivitiesDataComparisonModel.deserializeAPIModel(data.grossVolume),
          netVolume: ActivitiesDataComparisonModel.deserializeAPIModel(data.netVolume),
          payments: ActivitiesDataComparisonModel.deserializeAPIModel(data.payments),
          newCustomers: ActivitiesDataComparisonModel.deserializeAPIModel(data.newCustomers),
          newSubscriptions: ActivitiesDataComparisonModel.deserializeAPIModel(data.newSubscriptions),
      };
      return new ActivitiesModel(mappedData);
  }
}

export class ActivitiesDataComparisonModel {
  today: ActivitiesDataModel;
  thisPeriod: ActivitiesDataModel;
  constructor(data?: Partial<ActivitiesDataComparisonModel>) {
      this.today = new ActivitiesDataModel(data?.today);
      this.thisPeriod = new ActivitiesDataModel(data?.thisPeriod);
  }

  static deserializeAPIModel(data: IAPIDashboardActivityComparisonDataModel): ActivitiesDataComparisonModel {
      const mappedData: Partial<ActivitiesDataComparisonModel> = {
          today: ActivitiesDataModel.deserializeAPIModel(data.today),
          thisPeriod: ActivitiesDataModel.deserializeAPIModel(data.thisPeriod),
      };
      return new ActivitiesDataComparisonModel(mappedData);
  }
}

export class ActivitiesDataModel {
  value: number;
  up: boolean;
  percentage: number;
  constructor(data?: Partial<ActivitiesDataModel>) {
      this.value = data?.value || 0;
      this.up = data?.up || false;
      this.percentage = data?.percentage || 0;

      //we need to make sure percentage is always positive
      if (this.percentage < 0) {
          this.percentage = this.percentage * -1;
      }
  }

  static deserializeAPIModel(data: IAPIDashboardRecentActivityDataModel): ActivitiesDataModel {
      const mappedData: Partial<ActivitiesDataModel> = {
          value: data.value,
          up: data.up,
          percentage: data.percentage,
      };
      return new ActivitiesDataModel(mappedData);
  }
}
